"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var cluster = __importStar(require("./cluster"));
var decomposition = __importStar(require("./decomposition"));
var ensemble = __importStar(require("./ensemble"));
var feature_extraction = __importStar(require("./feature_extraction"));
var linear_model = __importStar(require("./linear_model"));
var metrics = __importStar(require("./metrics"));
var model_selection = __importStar(require("./model_selection"));
var neighbors = __importStar(require("./neighbors"));
var preprocessing = __importStar(require("./preprocessing"));
var tree = __importStar(require("./tree"));
// NOTE: For the browser bundling, we will temporarily ignore datasets and SVM API due to a few issues.
// These APIs won't be available for the browsers until there is a patch.
// @ts-ignore: ml module binding on window
window.ml = {
    cluster: cluster,
    decomposition: decomposition,
    ensemble: ensemble,
    feature_extraction: feature_extraction,
    linear_model: linear_model,
    metrics: metrics,
    model_selection: model_selection,
    neighbors: neighbors,
    preprocessing: preprocessing,
    tree: tree,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXgud2ViLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xpYi9pbmRleC53ZWIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsaURBQXFDO0FBQ3JDLDZEQUFpRDtBQUNqRCxtREFBdUM7QUFDdkMsdUVBQTJEO0FBQzNELDJEQUErQztBQUMvQyxpREFBcUM7QUFDckMsaUVBQXFEO0FBQ3JELHFEQUF5QztBQUN6Qyw2REFBaUQ7QUFDakQsMkNBQStCO0FBRS9CLHVHQUF1RztBQUN2Ryx5RUFBeUU7QUFFekUsMENBQTBDO0FBQzFDLE1BQU0sQ0FBQyxFQUFFLEdBQUc7SUFDVixPQUFPLFNBQUE7SUFDUCxhQUFhLGVBQUE7SUFDYixRQUFRLFVBQUE7SUFDUixrQkFBa0Isb0JBQUE7SUFDbEIsWUFBWSxjQUFBO0lBQ1osT0FBTyxTQUFBO0lBQ1AsZUFBZSxpQkFBQTtJQUNmLFNBQVMsV0FBQTtJQUNULGFBQWEsZUFBQTtJQUNiLElBQUksTUFBQTtDQUNMLENBQUMifQ==